"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeRow = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("office-ui-fabric-react/lib/Button");
var Dropdown_1 = require("office-ui-fabric-react/lib/Dropdown");
var TextField_1 = require("office-ui-fabric-react/lib/TextField");
var constants_1 = require("../../shared/constants");
var components_1 = require("../../shared/components");
var change_tracking_1 = require("../utils/change-tracking");
var NodeEdgeWeights_1 = require("./NodeEdgeWeights");
/**
 * NodeRow - A single editable strategy element row: name, outgoing edges
 * picker, per-target weights and the delete control.
 */
exports.NodeRow = function (_a) {
    var node = _a.node, nextLayerNodes = _a.nextLayerNodes, onUpdateNode = _a.onUpdateNode, onUpdateConnectionWeight = _a.onUpdateConnectionWeight, onDelete = _a.onDelete;
    var _b = components_1.useConfirmDialog(), confirm = _b.confirm, confirmDialog = _b.dialog;
    var connectOptions = nextLayerNodes.map(function (n) { return ({
        key: n.id,
        text: n.name,
    }); });
    var edges = node.edges || {};
    return (react_1.default.createElement("tr", null,
        react_1.default.createElement("td", null,
            react_1.default.createElement(TextField_1.TextField, { value: node.name, onChange: function (_, v) { return onUpdateNode({ name: v || "" }); }, placeholder: "Element name" })),
        react_1.default.createElement("td", null, nextLayerNodes.length > 0 ? (react_1.default.createElement(Dropdown_1.Dropdown, { multiSelect: true, placeholder: "Edges", options: connectOptions, selectedKeys: Object.keys(edges), onChange: function (_, option) {
                if (!option)
                    return;
                var targetId = option.key;
                var newEdges = option.selected
                    ? change_tracking_1.safeWriteEdge(edges, targetId, constants_1.DEFAULT_EDGE_WEIGHT)
                    : change_tracking_1.safeDeleteEdge(edges, targetId);
                onUpdateNode({ edges: newEdges });
            }, onRenderTitle: function (options) {
                var count = (options === null || options === void 0 ? void 0 : options.length) || 0;
                return count > 0 ? (react_1.default.createElement("span", null,
                    count,
                    " selected")) : (react_1.default.createElement("span", null, "Edges"));
            }, calloutProps: {
                calloutMaxHeight: 300,
                styles: { calloutMain: { width: "200%" } },
            } })) : (react_1.default.createElement("span", { className: "ws-no-connections" }, "No next layer"))),
        react_1.default.createElement("td", null,
            react_1.default.createElement(NodeEdgeWeights_1.NodeEdgeWeights, { edges: edges, nextLayerNodes: nextLayerNodes, onChangeWeight: onUpdateConnectionWeight })),
        react_1.default.createElement("td", null,
            react_1.default.createElement(Button_1.IconButton, { iconProps: { iconName: "Delete" }, title: "Delete Element", ariaLabel: "Delete Element", className: "ws-column-action-btn ws-admin-button-hover-danger", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var ok;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, confirm({
                                    title: "Delete element",
                                    message: "Are you sure you want to delete this element?",
                                    variant: "error",
                                    confirmText: "Delete",
                                })];
                            case 1:
                                ok = _a.sent();
                                if (ok)
                                    onDelete();
                                return [2 /*return*/];
                        }
                    });
                }); } }),
            confirmDialog)));
};
